import script from "./DeviceManager.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceManager.vue?vue&type=script&setup=true&lang=js"

import "./DeviceManager.vue?vue&type=style&index=0&id=2884c7e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2884c7e4"]])

export default __exports__